import { cva } from '@/styled-system/css';

export const labeledInputRecipe = cva({
  base: {
    'display': 'inline-block',
    'position': 'relative',
    'width': '100%',

    // Input styles
    '& > .c11n_input': {
      'paddingBlockStart': 'loose',
      'paddingBlockEnd': 'tighter',

      '&::placeholder': {
        transitionProperty: {
          _motionReduce: 'none',
          _motionSafe: 'color',
        },
        transitionDuration: {
          _motionReduce: '0s',
          _motionSafe: '{durations.150}',
        },
        transitionTimingFunction: '{easings.ease}',
      },

      '&:not(:focus)::placeholder': {
        color: 'transparent.invisible',
      },
    },

    // Label styles
    '& > .c11n_label': {
      'textStyle': 'body',
      'position': 'absolute',
      'insetInlineStart': 'default',
      'transform': 'translateY({spacing.default})',
      'transformOrigin': '0 0',
      'pointerEvents': 'none',
      'truncate': true,
      'maxWidth': 'calc(100% - {spacing.default})',

      '&:has(+ .c11n_input:focus), &:has(+ .c11n_input:not(:placeholder-shown)), &:has(+ .c11n_input:autofill), &:has(+ .c11n_input:read-only)':
        {
          textStyle: 'body-xs-bold',
          transform: 'translateY({spacing.tighter})',
        },

      'transitionProperty': {
        _motionReduce: 'none',
        _motionSafe: 'font-size, font-weight, line-height, transform',
      },
      'transitionDuration': {
        _motionReduce: '0s',
        _motionSafe: '{durations.150}',
      },
      'transitionTimingFunction': '{easings.ease}',
    },
  },
  variants: {
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        '& > .c11n_label': {
          insetInlineStart: 'none',
        },
      },
      false: {},
    },
  },
});
